import axiosClient from "../axiosInstance";

const base = "/admin";

const deleteEntry = async (entryId) => {
  return axiosClient.delete(`${base}/entries/${entryId}`).then((response) => {
    return response.data;
  });
};

const markEntryInvalid = async (entryId, reason = "") => {
  return axiosClient
    .patch(`${base}/entries/${entryId}/mark-invalid`, { reason })
    .then((response) => {
      return response.data;
    });
};

const restoreEntry = async (entryId) => {
  return axiosClient
    .patch(`${base}/entries/${entryId}/restore`, {})
    .then((response) => {
      return response.data;
    });
};

const getEntryAuditLog = async (entryId) => {
  return axiosClient
    .get(`${base}/entries/${entryId}/audit-log`)
    .then((response) => {
      return response.data;
    });
};

const getEntryPointsBreakdown = async (entryId) => {
  return axiosClient
    .get(`/entries/${entryId}/points-breakdown`)
    .then((response) => {
      return response.data;
    });
};

const recalculateAllEntries = async (data) => {
  return axiosClient
    .post(`${base}/recalculate-entries`, data)
    .then((response) => {
      return response.data;
    });
};

const adminService = {
  deleteEntry,
  markEntryInvalid,
  restoreEntry,
  getEntryAuditLog,
  getEntryPointsBreakdown,
  recalculateAllEntries,
};

export default adminService;
